import { JetView } from 'webix-jet';
import { allpayments } from 'models/allpayments';
import { devConfig } from 'config/config';

/**
 * Represents the view for the transaction report.
 * Extends the JetView class from webix-jet.
 */
export default class recordTableTransReportView extends JetView {
    /**
     * Configures the datatable view for the transaction report.
     * @returns {Object} The configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        const filterDetails = webix.ui({
            view: 'window',
            move: true,
            id: 'filterDetails',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Historial de Transacciones'),
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'datatable',
                id: 'dtDetails',
                css: 'webix_header_border webix_data_border webix_footer_border',
                select: true,
                columns: [
                    {
                        id: 'Id',
                        header: _('Ticket Det Id'),
                        width: 100,
                        sort: 'int',
                    },
                    { id: 'Type', header: _('Tipo'), width: 100, sort: 'int' },
                    {
                        id: 'TicketId',
                        header: _('Ticket ID'),
                        width: 100,
                        sort: 'int',
                    },
                    { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' },
                    {
                        id: 'TransactionId',
                        header: _('Transacción Id'),
                        width: 100,
                        sort: 'int',
                    },
                    {
                        id: 'Amount',
                        header: _('Monto'),
                        width: 100,
                        format: webix.i18n.priceFormat,
                        exportType: 'number',
                        sort: 'int',
                    },
                ],
            },
        });
        return {
            view: 'datatable',
            css: 'webix_header_border webix_data_border webix_footer_border',
            select: true,
            columns: [
                {
                    id: 'Id',
                    header: _('Ticket Det Id'),
                    width: 100,
                    sort: 'int',
                },
                { id: 'Type', header: _('Tipo'), width: 100, sort: 'int' },
                {
                    id: 'TicketId',
                    header: _('Ticket ID'),
                    width: 100,
                    sort: 'int',
                },
                { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' },
                {
                    id: 'TransactionId',
                    header: _('Transacción Id'),
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'Amount',
                    header: _('Monto'),
                    width: 100,
                    format: webix.i18n.priceFormat,
                    exportType: 'number',
                    sort: 'int',
                },
            ],
            loadahead: 0,
            datafetch: devConfig.getDefaultDataFetch(),
            pager: 'pagerA',
        };
    }

    /**
     * Initializes the datatable and sets up event listeners for user ID changes.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        var url = devConfig.geturlApi() + 'null/Report/GetBetHistoryTransactions';
        this.on(this.app, 'user:id', (idUser) => {
            grid.clearAll();
            grid.load(url + '?id=' + idUser);
            $$('dtDetails').clearAll();
            $$('dtDetails').load(url + '?id=' + idUser);
        });
    }
}

// FILE DOCUMENTED
